<template>
	<component v-if="pixelStreamerComponent"  :is="pixelStreamerComponent" :server-url="serverUrl" @go-to-board="goToBoard">
		<template #default="{showWaitingMessage}">
			<div v-if='showWaitingMessage' id='waiting-message-overlay'>
				<waiting-for-streaming v-if='pageStyle === PageStyle.FastPayTv'
															 :image-src='imageSrcForStyle'>
					<template #layout='{image}'>
						<v-row justify='center'>
							<v-col cols='4'>
								<v-img contain :src='image'></v-img>
							</v-col>
						</v-row>
						<v-row justify='center'>
							<v-col cols='4'>
								<div class='text-h6 waiting-message'>
									Welcome back.
								</div>
								<div class='text-h6 waiting-message'>
									Transmission will begin shortly.
								</div>
							</v-col>
						</v-row>
					</template>
				</waiting-for-streaming>
				<waiting-for-streaming v-else-if='pageStyle === PageStyle.SuperLotto'
															 :image-src='imageSrcForStyle'>
					<template #layout='{image}'>
						<v-row justify='center'>
							<v-col cols='4'>
								<v-img contain :src='image'></v-img>
							</v-col>
						</v-row>
						<v-row justify='center' align='center'>
							<v-col cols='4'>
								<div class='text-h6 waiting-message'>
									Please wait...
								</div>
							</v-col>
						</v-row>
					</template>
				</waiting-for-streaming>
				<waiting-for-streaming v-else-if='pageStyle === PageStyle.SiprizLotto'
															 :image-src='imageSrcForStyle'>
					<template #layout='{image}'>
						<v-row justify='center'>
							<v-col cols='4'>
								<v-img contain :src='image'></v-img>
							</v-col>
						</v-row>
						<v-row justify='center' align='center'>
							<v-col cols='6'>
								<div class='text-h6 waiting-message'>
									Welcome back, stream will begin shortly!
								</div>
								<div class='text-h6 waiting-message'>
									Good luck!
								</div>
							</v-col>
						</v-row>
					</template>
				</waiting-for-streaming>
				<waiting-for-streaming v-else-if='pageStyle === PageStyle.NoLimitLotto'
															 :image-src='imageSrcForStyle'>
					<template #layout='{image}'>
						<v-row justify='center'>
							<v-col cols='6'>
								<v-img contain :src='image'></v-img>
							</v-col>
						</v-row>
						<v-row justify='center' align='center'>
							<v-col cols='6'>
								<div class='text-h6 waiting-message'>
									Welcome back, stream will begin shortly!
								</div>
								<div class='text-h6 waiting-message'>
									Good luck!
								</div>
							</v-col>
						</v-row>
					</template>
				</waiting-for-streaming>
				<waiting-for-streaming v-else-if='pageStyle === PageStyle.TriplePlayLottery'
															 :image-src='imageSrcForStyle'>
					<template #layout='{image}'>
						<v-row justify='center'>
							<v-img contain :src="require('@/assets/img/tripleplayLottery/coin_1.png')" width="150px" style="position: absolute; bottom: 35px;left: 145px"></v-img>
							<v-img contain :src="require('@/assets/img/tripleplayLottery/coin_3.png')" width="150px" style="position: absolute; bottom: 35px;left: 145px"></v-img>
							<v-img contain :src="require('@/assets/img/tripleplayLottery/coin_2.png')" width="150px" style="position: absolute; bottom: 35px;right: 145px"></v-img>
							<v-img contain :src="require('@/assets/img/tripleplayLottery/coin_3.png')" width="150px" style="position: absolute; bottom: 35px;right: 145px"></v-img>
							<v-col cols='6'>
								<v-img contain :src='image'></v-img>
							</v-col>
						</v-row>
						<v-row justify='center' align='center'>
							<v-col cols='8'>
								<div class='text-h4 waiting-message'>
									Welcome back, stream will begin shortly!
								</div>
								<div class='text-h3 waiting-message'>
									Good luck!
								</div>
							</v-col>
						</v-row>
					</template>
				</waiting-for-streaming>
				<waiting-for-streaming v-else-if='pageStyle === PageStyle.EasyMoney'
															 :image-src='imageSrcForStyle'>
					<template #layout='{image}'>
						<v-row justify='center'>
							<v-col cols='6'>
								<v-img contain :src='image'></v-img>
							</v-col>
						</v-row>
						<v-row justify='center' align='center'>
							<v-col cols='8'>
								<div class='text-h4 waiting-message'>
									Welcome back, stream will begin shortly!
								</div>
								<div class='text-h5 waiting-message'>
									Good luck!
								</div>
							</v-col>
						</v-row>
					</template>
				</waiting-for-streaming>
				<waiting-for-streaming v-else message='Waiting for streaming...' :image-src='imageSrcForStyle'>
				</waiting-for-streaming>
			</div>
		</template>
	</component>
</template>

<script>
import WaitingForStreaming from '@homepage/components/WaitingForStreaming.vue';
import PageStyle from '@/enumerations/PageStyle.json';

import {launchSimulation} from '@/api/v2/stream.api.js';
import AdvancedPixelStreamer from "@homepage/components/pixelStreamer/AdvancedPixelStreamer.vue";
import OldPixelStreamer from "@homepage/components/pixelStreamer/OldPixelStreamer.vue";

// Wait at least 15 minutes waiting for streaming to start.
const MAX_MILLIS_TO_WAIT_FOR_SORTITION_STREAM = 900000;

export default {
	name: 'Stream',
	props: {
		sortition: {
			type: Object,
			required: true
		},
		pageStyle: {
			type: Number,
			required: true
		},
		pixelStreamVersion: {
			type: String,
			default: '5.0'
		},
		apiToken: {
			type: String,
			required: true
		}
	},
	components: {
		AdvancedPixelStreamer,
		OldPixelStreamer,
		WaitingForStreaming
	},
	mounted() {
		if (this.pixelStreamVersion === '5.0') {
			this.pixelStreamerComponent = OldPixelStreamer
		} else if (this.pixelStreamVersion === '5.3') {
			this.pixelStreamerComponent = AdvancedPixelStreamer
		} else {
			this.pixelStreamerComponent = OldPixelStreamer
		}
		if (this.pageStyle === PageStyle.LaQuickMoney) {
			this.$emit('change-style', {backgroundImage: require('@/assets/img/quickmoney/background.png')});
		} else if (this.pageStyle === PageStyle.TriplePlayLottery) {
			this.$emit('change-style', {backgroundImage: require('@/assets/img/tripleplayLottery/background.webp')});
		}
		this.launchSimulation();
	},
	data() {
		return {
			PageStyle,
			pixelStreamerComponent: null,
			timeouts: {
				launchSimulation: null,
				maxWait: null
			}
		};
	},
	destroyed() {
		clearTimeout(this.timeouts.launchSimulation);
		clearTimeout(this.timeouts.maxWait);
	},
	methods: {
		goToBoard() {
			this.$router.push({
				name: 'board',
				query: {
					apiToken: this.apiToken
				}
			});
		},
		launchSimulation() {
			launchSimulation({sortitionId: this.sortition.id, apiToken: this.apiToken}).then(response => {
				if (response.data.launchedSuccessfully) {
					console.log('Simulation launched successfully!');
				} else {
					this.timeouts.launchSimulation = setTimeout(this.launchSimulation, 4000);
					if (this.timeouts.maxWait === null) {
						this.timeouts.maxWait = setTimeout(this.goToBoard, MAX_MILLIS_TO_WAIT_FOR_SORTITION_STREAM);
					}
				}
			}).catch(() => {
				this.timeouts.launchSimulation = setTimeout(this.launchSimulation, 4000);
				if (this.timeouts.maxWait === null) {
					this.timeouts.maxWait = setTimeout(this.goToBoard, MAX_MILLIS_TO_WAIT_FOR_SORTITION_STREAM);
				}
			});
		},
	},
	computed: {
		serverUrl() {
			return 'wss://prod-proxy.lotocentral.net';
		},
		imageSrcForStyle() {
			if (this.pageStyle === PageStyle.LaQuickMoney) {
				return require('@/assets/img/quickmoney/logo.png');
			} else if (this.pageStyle === PageStyle.PremierLotto) {
				return require('@/assets/img/premierlotto/logo.png');
			} else if (this.pageStyle === PageStyle.FastPayTv) {
				return require('@/assets/img/fastpaytv/logo.png');
			} else if (this.pageStyle === PageStyle.SuperLotto) {
				return require('@/assets/img/superlotto/logo_colored.png');
			} else if (this.pageStyle === PageStyle.SiprizLotto) {
				return require('@/assets/img/siprizlotto/logo.png');
			} else if (this.pageStyle === PageStyle.CaribbeanPick) {
				return require('@/assets/img/caribbeanPick/logo.png');
			} else if (this.pageStyle === PageStyle.NoLimitLotto) {
				return require('@/assets/img/nolimit/logo.png');
			} else if (this.pageStyle === PageStyle.ParadiseLottery) {
				return require('@/assets/img/paradiseLottery/logo.png');
			} else if (this.pageStyle === PageStyle.TriplePlayLottery) {
				return require('@/assets/img/tripleplayLottery/logo.png');
			} else if (this.pageStyle === PageStyle.ArgentinaLottery) {
				return require('@/assets/img/argentinaLottery/logo.png');
			} else if (this.pageStyle === PageStyle.EasyMoney) {
				return require('@/assets/img/easymoney/logo.png');
			} else if (this.pageStyle === PageStyle.QuickLotto) {
				return require('@/assets/img/quicklotto/logo.png');
			} else if (this.pageStyle === PageStyle.FantastikLottery) {
				return require('@/assets/img/fantastikLottery/logo.png');
			}

			return null;
		}
	}
};
</script>

<style scoped>
#waiting-message-overlay {
	position: absolute;
	top: 0px;
	left: 0px;
	width: 100%;
	height: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
	background: #80808054;
}

::v-deep video {
	position: absolute;
	left: 0;
	width: 100%;
	height: 100%;
	object-fit: fill;
}
</style>
